export default {
  namespaced: true,

  state: {
    msg: "",
    status: "", // 'success', 'error', etc.
  },

  mutations: {
    SET_NOTIFICATION(state, { msg, status }) {
      state.msg = msg;
      state.status = status;
    },
    CLEAR_NOTIFICATION(state) {
      state.msg = "";
      state.status = "";
    },
  },

  actions: {
    setNotificacion({ commit, dispatch }, { msg, status }) {
      commit("SET_NOTIFICATION", { msg, status });

      // Limpiar después de 5 segundos
      setTimeout(() => {
        dispatch("clearNotificacion");
      }, 5000);
    },
    clearNotificacion({ commit }) {
      commit("CLEAR_NOTIFICATION");
    },
  },
};
